import { MessageSquare } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface AbandonConversationDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * AbandonConversationDialog - Confirm dialog for abandoning incomplete conversation
 *
 * Shown when user clicks "New Chat" while having an incomplete conversation.
 * Informs user that they can find the conversation in history.
 */
export function AbandonConversationDialog({
  open,
  onConfirm,
  onCancel,
}: AbandonConversationDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <MessageSquare className="h-5 w-5 text-amber-500" />
            {t('chat:abandon.title')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t('chat:abandon.description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>
            {t('chat:abandon.stay')}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {t('chat:abandon.leave')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

